import { AppLinks } from 'utilities/Constants';
import { t } from 'utilities/TranslationUtils';
import { useStores } from 'index';

export const AppFooter = () => {
  const { languageStore } = useStores();

  const pkg = require('../../../package.json');
  return (
    <footer className='app-footer py-3'>
      <div className='row'>
        <div className='col-md-4 text-center text-md-left mb-3 mb-md-0 align-content-center'>
          <p className='mb-0'>
            {t('common.copyright', { copySign: '\u00A9', currentYear: new Date().getFullYear() })}
            <span className='text-white'> {pkg.version}</span>
          </p>
        </div>

        <ul className='col-12 md-0 col-md-5 d-flex list-unstyled mb-0 justify-content-center align-content-center'>
          <li className='px-2 align-content-center'>
            <a href={AppLinks.About + languageStore.lngQueryString} target='_blank' className='text-link'>
              {t('common.about')}
            </a>
          </li>
          <li className='px-2 align-content-center'>
            <a href={AppLinks.Terms + languageStore.lngQueryString} target='_blank' className='text-link'>
              {t('common.terms')}
            </a>
          </li>
          <li className='px-2 align-content-center'>
            <a href={AppLinks.Support} target='_blank' className='text-link'>
              {t('common.support')}
            </a>
          </li>
          <li className='px-2 align-content-center'>
            <a href={AppLinks.Contact} target='_blank' className='text-link'>
              {t('common.contact')}
            </a>
          </li>
        </ul>

        <ul className='col-md-3 d-flex list-unstyled mb-0 justify-content-center justify-content-md-end align-content-center'>
          <li className='px-2'>
            <a href={AppLinks.Facebook} target='_blank' className='ico-link'>
              {Icons.facebook}
            </a>
          </li>
          <li className='px-2'>
            <a href={AppLinks.Twitter} target='_blank' className='ico-link'>
              {Icons.twitter}
            </a>
          </li>
          <li className='px-2 pr-md-0'>
            <a href={AppLinks.LinkedIn} target='_blank' className='ico-link'>
              {Icons.linkedin}
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

const Icons = {
  linkedin: (
    <svg xmlns='http://www.w3.org/2000/svg' width='26' height='25' viewBox='0 0 26 25'>
      <g fill='none' fillRule='evenodd' opacity='.75'>
        <rect width='25.2' height='24.2' x='.4' y='.4' stroke='#4A4A4A' strokeWidth='.8' opacity='.8' rx='12.1' />
        <path
          fill='#4A4A4A'
          fillRule='nonzero'
          d='M7.879 10.594v6.929h2.193v-6.93H7.879zm1.24-3.336c-.75 0-1.24.518-1.24 1.197 0 .665.476 1.198 1.212 1.198h.014c.765 0 1.24-.533 1.24-1.198-.013-.68-.475-1.197-1.226-1.197zm6.188 3.336c-1.164 0-1.685.672-1.976 1.144v-.981h-2.193c.029.65 0 6.929 0 6.929h2.193v-3.87c0-.207.014-.414.072-.562.159-.414.52-.842 1.125-.842.794 0 1.111.635 1.111 1.567v3.706h2.193v-3.972c0-2.129-1.082-3.12-2.525-3.12z'
          opacity='.8'
        />
      </g>
    </svg>
  ),
  facebook: (
    <svg xmlns='http://www.w3.org/2000/svg' width='26' height='25' viewBox='0 0 26 25'>
      <g fill='none' fillRule='evenodd' opacity='.75'>
        <rect width='25.2' height='24.2' x='.4' y='.4' stroke='#4A4A4A' strokeWidth='.8' opacity='.8' rx='12.1' />
        <path
          fill='#4A4A4A'
          d='M13.754 18.548v-5.443h1.722l.282-2.42h-2.004V9.507c0-.623.017-1.24.924-1.24h.919v-1.73c0-.027-.79-.085-1.588-.085-1.668 0-2.712 1.002-2.712 2.842v1.391H9.455v2.42h1.842v5.443h2.457z'
          opacity='.8'
        />
      </g>
    </svg>
  ),
  twitter: (
    <svg xmlns='http://www.w3.org/2000/svg' width='26' height='25' viewBox='0 0 26 25'>
      <g fill='none' fillRule='evenodd' opacity='.75'>
        <rect width='25.2' height='24.2' x='.4' y='.4' stroke='#4A4A4A' strokeWidth='.8' opacity='.8' rx='12.1' />
        <path
          fill='#4A4A4A'
          d='M10.808 16.935c4.46 0 6.899-3.723 6.899-6.952 0-.106 0-.211-.008-.316a4.952 4.952 0 0 0 1.21-1.265 4.799 4.799 0 0 1-1.392.385 2.45 2.45 0 0 0 1.066-1.352 4.837 4.837 0 0 1-1.54.593 2.414 2.414 0 0 0-3.43-.106 2.459 2.459 0 0 0-.702 2.335 6.87 6.87 0 0 1-4.998-2.553 2.456 2.456 0 0 0 .752 3.262 2.392 2.392 0 0 1-1.101-.306v.031a2.44 2.44 0 0 0 1.945 2.395 2.393 2.393 0 0 1-1.094.042 2.429 2.429 0 0 0 2.265 1.697 4.84 4.84 0 0 1-3.59 1.013 6.827 6.827 0 0 0 3.718 1.096'
          opacity='.8'
        />
      </g>
    </svg>
  ),
};
